import { render, staticRenderFns } from "./StaffBasicInfoDialog.vue?vue&type=template&id=fafdab96&scoped=true"
import script from "./StaffBasicInfoDialog.vue?vue&type=script&lang=js"
export * from "./StaffBasicInfoDialog.vue?vue&type=script&lang=js"
import style0 from "./StaffBasicInfoDialog.vue?vue&type=style&index=0&id=fafdab96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fafdab96",
  null
  
)

export default component.exports